import { DELIVERY_CALENDAR_THEME } from "../delivery/deliveryCalendar";
import { modalStyle } from "./adminDashboardStyles";

export const therapeuticTdStyle = {
    padding: "14px 12px",
    fontSize: "14px",
    color: "#122A26",
};

export const therapeuticRowStyle = {
    borderBottom: "1px solid rgba(12,59,60,.08)",
};

export const therapeuticEmptyStyle = {
    margin: 0,
    color: "#5A6D68",
    fontSize: "14px",
};

export const therapeuticSuccessStyle = {
    color: "#0C3B3C",
    background: "#e9f8f1",
    border: "1px solid rgba(23,185,120,.36)",
    borderRadius: "8px",
    padding: "10px 12px",
    fontSize: "13px",
    fontWeight: 800,
    margin: 0,
};

export const therapeuticModalStyle = {
    ...modalStyle,
    width: 640,
    borderRadius: "8px",
    border: "1px solid rgba(12,59,60,.12)",
    color: "#122A26",
    fontFamily: "Manrope, Arial, Helvetica, sans-serif",
};

export const therapeuticModalTitleStyle = {
    margin: 0,
    fontSize: "20px",
    color: "#0C3B3C",
    fontFamily: "Fraunces, Georgia, serif",
    fontWeight: 700,
    letterSpacing: 0,
};

export const therapeuticClassBadgeStyle = (productClass) => {
    const palette = {
        MEDICAMENT: { bg: "#e9f8f1", text: "#0C3B3C", border: "rgba(23,185,120,.36)" },
        DISPOSITIF_MEDICAL: { bg: "#F4F1EA", text: "#0C3B3C", border: "rgba(12,59,60,.18)" },
        COMPLEMENT_NUTRITIONNEL: { bg: "#fff8e6", text: "#775818", border: "rgba(200,164,77,.42)" },
    }[productClass] || { bg: "#f3f4f6", text: "#374151", border: "#e5e7eb" };
    return {
        display: "inline-flex",
        alignItems: "center",
        minHeight: "26px",
        padding: "0 10px",
        borderRadius: "999px",
        background: palette.bg,
        color: palette.text,
        border: `1px solid ${palette.border}`,
        fontSize: "12px",
        fontWeight: 800,
        whiteSpace: "nowrap",
    };
};

export const therapeuticSuggestionsStyle = {
    position: "absolute",
    top: "calc(100% + 6px)",
    left: 0,
    right: 0,
    background: "white",
    border: "1px solid rgba(12,59,60,.16)",
    borderRadius: "8px",
    boxShadow: "0 14px 36px rgba(12,59,60,0.18)",
    zIndex: 20,
    maxHeight: "260px",
    overflowY: "auto",
    padding: "6px",
};

export const therapeuticSuggestionButtonStyle = {
    width: "100%",
    border: "none",
    background: "white",
    borderRadius: "6px",
    padding: "10px 12px",
    cursor: "pointer",
    textAlign: "left",
    display: "grid",
    gap: "4px",
};

export const therapeuticSelectedReferenceStyle = {
    border: "1px solid rgba(23,185,120,.36)",
    background: "#e9f8f1",
    borderRadius: "8px",
    padding: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
};

export const deliveryModalStyle = {
    background: "white",
    borderRadius: "16px",
    boxShadow: "0 28px 70px rgba(12,59,60,0.26)",
    width: "min(92vw, 980px)",
    maxHeight: "calc(100vh - 48px)",
    overflow: "hidden",
};

export const deliveryModalFormStyle = { display: "grid", gridTemplateRows: "auto minmax(0, 1fr) auto", maxHeight: "calc(100vh - 48px)" };

export const deliveryModalHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "24px",
    padding: "24px 28px",
    borderBottom: `1px solid ${DELIVERY_CALENDAR_THEME.border}`,
};

export const deliveryModalTitleStyle = {
    margin: 0,
    color: DELIVERY_CALENDAR_THEME.ink,
    fontFamily: "Fraunces, Georgia, serif",
    fontSize: "26px",
    fontWeight: 800,
    lineHeight: 1.12,
};

export const deliveryModalSubtitleStyle = {
    margin: "10px 0 0",
    color: DELIVERY_CALENDAR_THEME.gray,
    fontSize: "16px",
    lineHeight: 1.45,
};

export const deliveryModalCloseButtonStyle = {
    border: "none",
    background: DELIVERY_CALENDAR_THEME.cream,
    borderRadius: "999px",
    width: "46px",
    height: "46px",
    cursor: "pointer",
    fontSize: "36px",
    lineHeight: "42px",
    color: DELIVERY_CALENDAR_THEME.gray,
    flexShrink: 0,
};

export const deliveryModalBodyStyle = {
    overflowY: "auto",
    padding: "28px",
    display: "grid",
    gap: "22px",
};

export const deliveryInputStyle = {
    padding: "13px 15px",
    border: "1px solid rgba(12,59,60,.16)",
    borderRadius: "8px",
    fontSize: "16px",
    boxSizing: "border-box",
    width: "100%",
    minHeight: "50px",
    color: DELIVERY_CALENDAR_THEME.ink,
    background: "#f8f5ee",
    boxShadow: "inset 0 1px 0 rgba(12,59,60,.04)",
};

export const deliveryLabelStyle = {
    color: DELIVERY_CALENDAR_THEME.gray,
    fontSize: "14px",
    fontWeight: 800,
    marginBottom: "10px",
};

export const deliverySectionTitleStyle = {
    margin: 0,
    color: DELIVERY_CALENDAR_THEME.petrol,
    fontSize: "16px",
    fontWeight: 900,
    textTransform: "uppercase",
};

export const deliverySegmentStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "5px",
    borderRadius: "8px",
    background: DELIVERY_CALENDAR_THEME.petrolTint,
    width: "fit-content",
    maxWidth: "100%",
    flexWrap: "wrap",
};

export const deliverySegmentButtonStyle = (active) => ({
    border: "none",
    background: active ? "white" : "transparent",
    color: active ? DELIVERY_CALENDAR_THEME.petrol : DELIVERY_CALENDAR_THEME.gray,
    borderRadius: "7px",
    minHeight: "44px",
    padding: "0 22px",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: 800,
    boxShadow: active ? "0 2px 8px rgba(12,59,60,.10)" : "none",
});

export const deliveryDateGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(220px, 1fr))",
    gap: "20px",
};

export const deliveryCountBadgeStyle = {
    minWidth: "38px",
    height: "34px",
    borderRadius: "999px",
    background: DELIVERY_CALENDAR_THEME.petrolTint,
    color: DELIVERY_CALENDAR_THEME.petrol,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "17px",
    fontWeight: 900,
};

export const deliveryLinkButtonStyle = {
    border: "none",
    background: "transparent",
    color: DELIVERY_CALENDAR_THEME.petrol,
    padding: 0,
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: 800,
    textDecoration: "underline",
};

export const deliveryEhpadPanelStyle = {
    border: "1px solid rgba(12,59,60,.12)",
    borderRadius: "12px",
    padding: "16px 18px",
    background: "white",
    display: "grid",
    gap: "14px",
};

export const deliveryEhpadListStyle = {
    maxHeight: "260px",
    minHeight: "120px",
    overflowY: "auto",
    display: "grid",
    gap: "8px",
    paddingRight: "4px",
};

export const deliveryEhpadButtonStyle = (active) => ({
    display: "flex",
    gap: "12px",
    alignItems: "center",
    border: `1px solid ${active ? "rgba(23,185,120,.45)" : "rgba(12,59,60,.10)"}`,
    background: active ? "#f3fbf6" : "white",
    borderRadius: "8px",
    padding: "12px 14px",
    width: "100%",
    cursor: "pointer",
    textAlign: "left",
});

export const deliveryCheckboxStyle = (checked, partial) => ({
    width: "24px",
    height: "24px",
    borderRadius: "7px",
    background: checked || partial ? DELIVERY_CALENDAR_THEME.petrol : "white",
    border: `1px solid ${checked || partial ? DELIVERY_CALENDAR_THEME.petrol : "rgba(12,59,60,.24)"}`,
    color: "white",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: 900,
    flexShrink: 0,
});

export const deliverySubgroupButtonStyle = (active) => ({
    border: `1px solid ${active ? DELIVERY_CALENDAR_THEME.validation : "rgba(12,59,60,.14)"}`,
    background: active ? "#e9f8f1" : "white",
    color: active ? DELIVERY_CALENDAR_THEME.petrol : DELIVERY_CALENDAR_THEME.gray,
    borderRadius: "8px",
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 800,
});

export const deliverySelectedTargetStyle = {
    border: `1px solid ${DELIVERY_CALENDAR_THEME.petrolTint}`,
    background: "#f3fbf6",
    color: DELIVERY_CALENDAR_THEME.petrol,
    borderRadius: "8px",
    padding: "7px 10px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 800,
};

export const deliveryModalFooterStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "20px",
    padding: "18px 28px",
    borderTop: `1px solid ${DELIVERY_CALENDAR_THEME.border}`,
    background: "white",
};

export const deliveryCancelButtonStyle = {
    minHeight: "50px",
    padding: "0 28px",
    borderRadius: "12px",
    border: `1px solid ${DELIVERY_CALENDAR_THEME.border}`,
    background: "white",
    color: DELIVERY_CALENDAR_THEME.ink,
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: 800,
};

export const deliverySubmitButtonStyle = {
    minHeight: "50px",
    padding: "0 30px",
    borderRadius: "12px",
    border: "none",
    background: "#169f6d",
    color: "white",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: 900,
};

export const deliveryDeleteButtonStyle = {
    minHeight: "50px",
    padding: "0 24px",
    borderRadius: "12px",
    border: "1px solid #fca5a5",
    background: "white",
    color: "#b91c1c",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: 800,
};
